import type { MemosState } from '../types/memos-state.type';

export const emptyMemosState: MemosState = {
  internalMemo: undefined,
  memo: undefined,
  hasBeenMemoed: false,
  isOpenMemoDialog: false,
} as const;
